export const AnswerVisibility = {
  'Visible to Agents Only': 1,
  'Visible to Operators Only': 2,
  'Visible to Agents and Operators': 3,
  'Visible to Creator Operator': 4
};
